import { render, staticRenderFns } from "./ProjectTabs.vue?vue&type=template&id=ceaa51ae&scoped=true"
import script from "./ProjectTabs.vue?vue&type=script&lang=js"
export * from "./ProjectTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectTabs.vue?vue&type=style&index=0&id=ceaa51ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceaa51ae",
  null
  
)

export default component.exports